import { render, staticRenderFns } from "./AccountStrategy.vue?vue&type=template&id=f511839e&"
import script from "./AccountStrategy.vue?vue&type=script&lang=js&"
export * from "./AccountStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports